import Image from "next/image";
import bgImg from "@/asset/images/bg-5.png";
import bgImgMobile from "@/asset/images/mobile/bg-5.png";
import { useEffect } from "react";
import { useState } from "react";

export default function WhyUsSection() {
  const [isMobile, setIsMobile] = useState(false);

  // This ensures animations only start after component is fully mounted
  useEffect(() => {
    // Initial check for mobile
    setIsMobile(window.innerWidth < 768);

    // Add window resize listener
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <section className='bg-white h-fit md:min-h-[450px] lg:min-h-[600px] flex items-end lg:items-center justify-center'>
      <div className='w-full max-w-[1064px] flex flex-col-reverse md:flex-row items-center gap-0 lg:gap-12 h-fit'>
        {/* Image - Hidden on very small screens, visible and responsive on others */}
        <div className='w-full max-w-[243px] md:max-w-[350px] lg:max-w-[450px]'>
          <Image
            alt='Why work with us'
            src={isMobile ? bgImgMobile.src : bgImg.src}
            width={395}
            height={402}
            // className='w-full h-auto'
            priority
          />
        </div>

        {/* Content */}
        <div className='space-y-4 md:space-y-6 text-left pb-10 px-6'>
          <h1 className='text-accent text-[24px] md:text-[40px] lg:text-[68px] leading-tight lg:leading-[88px] font-bold'>
            Why work
            <br className='hidden lg:block' /> with us?
          </h1>
          <h4 className='text-black text-base md:text-lg lg:text-xl max-w-[600px]'>
            With extensive industry experience and deep connections in the
            crypto space, we provide end-to-end marketing solutions to boost
            your brand's visibility and credibility. Whether you need expert PR
            management, content creation, or community engagement strategies,
            we've got you covered.
          </h4>
        </div>
      </div>
    </section>
  );
}
